export default __webpack_public_path__ + "static/media/green-next-arrow.8bca8aef.svg";